import { rgba } from 'polished';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Avatar, Initials, tokens } from '@treams/treams-ui';

import { ISelectOptionElementProps, ISelectOptionInnerProps } from '../forms/controls/Select';

interface IRecipientSelectorOptionProps extends ISelectOptionElementProps {
	label: string;
	data?: any;
	innerProps: ISelectOptionInnerProps;
}

const OptionElement = styled.div<ISelectOptionElementProps>`
	cursor: pointer;
	color: ${rgba(tokens.text.primary, 0.6)};
	font-size: 16px;
	padding: 0;
	border-top: 1px solid ${tokens.border.subtle};

	&:hover {
		background-color: transparent;
		color: ${rgba(tokens.text.primary, 1)};
	}

	${(props) =>
		props.isFocused &&
		`
		background-color: transparent;
		color: ${rgba(tokens.text.primary, 1)};
	`}

	&:active {
		border-top-color: ${tokens.border.subtle};
		background-color: ${tokens.border.subtle};

		& + .react-select__option {
			border-top: 1px solid ${tokens.border.subtle};
		}
	}
`;

const RecipientSelectorOption = ({
	label,
	data,
	isFocused,
	isSelected,
	innerProps,
}: IRecipientSelectorOptionProps) => {
	return (
		<OptionElement
			isFocused={isFocused}
			isSelected={isSelected}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...innerProps}
		>
			<Flex flexDirection="row" alignItems="center">
				<Box my={3} ml={3}>
					{data.data != null ? (
						<Avatar user={data.data} size={24} />
					) : (
						<Initials user={{ firstName: '@', lastName: '' }} size={24} />
					)}
				</Box>

				<Box my={3} ml={2} mr={3}>
					{label}
				</Box>
			</Flex>
		</OptionElement>
	);
};

export default RecipientSelectorOption;
